<script setup lang="ts">
const runtimeConfig = useRuntimeConfig()

useSeoMeta({
  title: 'エラー | Code & Magic',
  description: 'エラー。',
  ogTitle: 'エラー',
  ogDescription: 'エラー。',
  ogImage: `${runtimeConfig.public.serviceDomain}/images/ogPlayMakeShare_wLogo.webp`,
  twitterCard: 'summary_large_image',
})

const error = useError()
</script>

<template>
  <v-app id="app">
    <!-- <Header /> -->

    <v-main
      id="main"
      class="bg-grey-lighten-3 background-gutter"
    >
      <v-img
        src="@/assets/images/landing/NotFound.webp"
        class="bg-image"
        contain
      >
        <v-container class="fill-height">
          <v-row
            class="fill-height"
            align="center"
            justify="center"
          >
            <v-col
              col="auto"
              align="center"
            >
              <v-card
                class="message d-flex flex-column"
                rounded="lg"
              >
                <v-card-text>
                  <div style="max-width: 70%;">
                    <BrandTextLogo />
                  </div>
                  <div class="status-code">
                    {{ error?.statusCode }}
                  </div>
                  <template v-if="error?.statusCode === undefined" />
                  <template v-else-if="error?.statusCode === 404">
                    <h1>ページが見つかりません</h1>
                    <p>{{ error?.message }}</p>
                  </template>
                  <template v-else>
                    <h1>エラーが発生しました</h1>
                    <p>{{ error?.message }}</p>
                  </template>
                </v-card-text>
                <v-card-actions class="justify-center mt-auto">
                  <v-btn
                    size="x-large"
                    variant="outlined"
                    to="/"
                  >
                    ホームに戻る
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-img>
    </v-main>

    <!-- <SkeletalFooter /> -->
  </v-app>
</template>

<style scoped>
#main {
  background-color: #202020;
  padding: 0;
  /* overflow: hidden; */
}

#main .container {
  padding: 0;
  margin-left: auto;
  width: 100%;
}

.bg-image {
  width: 100vw;
  height: 100vh;

  position: relative;
}

.message {
  background-color: #222222f0;
  color: white;
  width: clamp(533px, 75vw, 960px);
  height: clamp(400px, 56.25vw, 720px);
  /* margin: auto auto; */
  padding: 32px;
}

.message .status-code {
  font-family: 'Google Sans Code', sans-serif;
  font-size: 160px;
}
</style>
